import { Injectable } from '@angular/core';
import { StorageWebService } from './storage.service';

@Injectable()
export class LocalStorageService extends StorageWebService {
  constructor() {
    super(localStorage);
  }
}
